import { SelectAsyncInput } from '@core/components/Select';
import indicadorOperacaoIbsCbsApi from 'app/services/api/servicoFiscal/indicadorOperacaoIbsCbsApi';
import React, { useRef, useState, useEffect } from 'react';

const SelectIndicadorOperacaoIbsCbs = ({ id, name, label, value, touched, error, onBlur, onChange, disabled, required = false }) => {
  const allDataRef = useRef(null);
  const PAGE_SIZE = 50;
  const [selectedValue, setSelectedValue] = useState(null);

  // Buscar objeto completo quando value for uma string (código)
  useEffect(() => {
    const buscarObjetoPorCodigo = async () => {
      // Se value é um objeto válido (tem id), usa diretamente
      if (value && typeof value === 'object' && value.id) {
        setSelectedValue(value);
        return;
      }

      // Se value é uma string (código), busca o objeto completo
      if (typeof value === 'string' && value) {
        try {
          // Busca todos os dados se ainda não foram carregados
          if (!allDataRef.current) {
            const response = await indicadorOperacaoIbsCbsApi.pesquisarIndicadorOperacaoIbsCbs({
              size: 100,
              sort: 'codigo',
              page: 0,
              q: '',
            });
            allDataRef.current = {
              query: '',
              data: response?.data || [],
            };
          }

          // Encontra o objeto com o código correspondente
          const objeto = allDataRef.current.data.find(item => item.codigo === value);
          if (objeto) {
            setSelectedValue(objeto);
          } else {
            setSelectedValue(null);
          }
        } catch (error) {
          console.error('Erro ao buscar indicador operação IBS CBS:', error);
          setSelectedValue(null);
        }
      } else {
        setSelectedValue(null);
      }
    };

    buscarObjetoPorCodigo();
  }, [value]);

  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={selectedValue}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      disabled={disabled}
      required={required}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }

        // Se mudou a query, limpa o cache
        if (allDataRef.current && allDataRef.current.query !== query) {
          allDataRef.current = null;
        }

        // Se não tem cache, busca todos os dados da API
        if (!allDataRef.current) {
          const response = await indicadorOperacaoIbsCbsApi.pesquisarIndicadorOperacaoIbsCbs({
            size: 100,
            sort: 'codigo',
            page: 0,
            q: query,
          });

          allDataRef.current = {
            query,
            data: response?.data || [],
          };
        }

        // Paginação no frontend
        const allData = allDataRef.current.data;
        const startIndex = next * PAGE_SIZE;
        const endIndex = startIndex + PAGE_SIZE;
        const paginatedData = allData.slice(startIndex, endIndex);
        const hasNextPage = endIndex < allData.length;
        return {
          data: paginatedData,
          nextPage: hasNextPage ? next + 1 : null,
          totalItems: allData.length,
        };
      }}
      fetchOnFocus
    />
  );
};

export default SelectIndicadorOperacaoIbsCbs;
